import { useState } from "react";
import { SplitLines } from "@/components/fx/Reveal";
import { SectionCta } from "@/components/SectionCta";

const OLD = ["Annuncio generico", "Il titolare legge CV la sera", "Colloquio di mezz'ora", "Decisione a istinto", "Si incrociano le dita"];
const NEW = ["Brief preciso", "Ricerca attiva con campagne e contenuti veri", "Filtro, CV, video e test", "Colloquio strutturato", "Incontri solo i migliori"];

const Flow = ({ items, mine }) => (
  <ol key={mine ? "noi" : "solito"} className="relative grid gap-4 lg:grid-cols-5 lg:gap-5" data-testid={mine ? "confronto-list-noi" : "confronto-list-solito"}>
    <span className={`absolute left-[19px] top-4 bottom-4 w-px lg:left-4 lg:right-4 lg:top-[19px] lg:bottom-auto lg:h-px lg:w-auto ${mine ? "bg-[#0F6E56]" : "border-l border-dashed border-[#8A887F] lg:border-l-0 lg:border-t"}`} aria-hidden="true" />
    {items.map((it, i) => {
      const last = i === items.length - 1;
      return (
        <li key={it} className="relative flex gap-4 lg:flex-col" style={{ animation: `rl-pop .6s ${i * 90}ms both cubic-bezier(.2,.8,.2,1)` }}>
          <span
            className={`relative z-10 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-mono-data text-[13px] ${
              mine ? (last ? "bg-[#EF9F27] text-[#2C2C2A] shadow-[0_0_0_8px_rgba(239,159,39,0.18)]" : "bg-[#0F6E56] text-white") : "border border-dashed border-[#8A887F] bg-[#F7F6F2] text-[#6B6961]"
            }`}
          >
            {String(i + 1).padStart(2, "0")}
          </span>
          <div className={`flex-1 rounded-2xl border p-5 lg:min-h-[132px] ${mine ? (last ? "border-[#EF9F27] bg-[#FBE6C2]/50" : "border-[#BCE3D6] bg-white") : "border-[#E7E5DF] bg-[#F7F6F2]"}`}>
            <p className={`font-display text-lg leading-snug tracking-[-0.01em] ${mine ? "text-[#2C2C2A]" : "text-[#6B6961] line-through decoration-[#8A887F]/40 decoration-1"}`}>{it}</p>
          </div>
        </li>
      );
    })}
  </ol>
);

export const Confronto = ({ eyebrow = "Confronto", lines = ["La differenza sta tutta", "nel processo."], oldLabel = "Come si fa di solito", newLabel = "Come lo facciamo noi", oldItems = OLD, newItems = NEW, cta = null }) => {
  const [mine, setMine] = useState(true);
  return (
    <section id="confronto" className="rl-section relative border-t border-[#E7E5DF] bg-white py-28 lg:py-40" data-testid="confronto-section">
      <div className="rl-container">
        <p className="rl-eyebrow text-[#0F6E56]">{eyebrow}</p>
        <div className="mt-6 flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <SplitLines className="rl-h2 max-w-[820px]" lines={lines} data-testid="confronto-title" />
          <div role="group" aria-label="Scegli il confronto" className="relative inline-grid w-full grid-cols-2 rounded-full border border-[#E7E5DF] bg-[#F7F6F2] p-1.5 sm:w-auto" data-testid="confronto-toggle">
            <span className={`absolute bottom-1.5 top-1.5 w-[calc(50%-6px)] rounded-full transition-[transform,background-color] duration-500 ease-out ${mine ? "translate-x-[calc(100%)] bg-[#0F6E56]" : "translate-x-0 bg-[#2C2C2A]"}`} style={{ left: 6 }} aria-hidden="true" />
            <button type="button" aria-pressed={!mine} onClick={() => setMine(false)} className={`relative z-10 rounded-full px-4 py-3 text-[14px] font-medium transition-colors sm:px-6 ${!mine ? "text-white" : "text-[#2C2C2A]"}`} data-testid="confronto-toggle-solito">
              {oldLabel}
            </button>
            <button type="button" aria-pressed={mine} onClick={() => setMine(true)} className={`relative z-10 rounded-full px-4 py-3 text-[14px] font-medium transition-colors sm:px-6 ${mine ? "text-white" : "text-[#2C2C2A]"}`} data-testid="confronto-toggle-noi">
              {newLabel}
            </button>
          </div>
        </div>
        <div className="mt-14 lg:mt-20">
          <p className="mb-6 font-mono-data text-[12px] uppercase tracking-[0.16em] text-[#6B6961]" aria-live="polite" data-testid="confronto-current-label">
            {mine ? newLabel : oldLabel}
          </p>
          {mine ? <Flow items={newItems} mine /> : <Flow items={oldItems} mine={false} />}
          {cta && <SectionCta label={cta} testId="confronto-cta" />}
        </div>
      </div>
    </section>
  );
};
